'use strict';

import Component from 'generic.basecomponent';
import $ from 'jquery';
import '../../../general/js/jquery.fancybox';

export default class LightBox extends Component {
    constructor(el) {
        super(el);
        this.$container = $(this.container);
        this.init();
    }

    init() {
        let $container = this.$container;
        let title = $container.data('title') || '';
        let text = $container.data('footer') || '';
        let caption = title || text ? `<h3>${title}</h3><div>${text}</div>` : undefined;
        this.$container.fancybox({
            caption: caption
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/lightbox/js/generic.lightbox.js